// src/i18n.ts
import { createI18n } from "vue-i18n";

// Import JSON translations
import en from "./locales/en.json";

// Define message schema (Optional for better type safety)
type MessageSchema = typeof en;

// Create i18n instance with type support
const i18n = createI18n<[MessageSchema], "en">({
  legacy: false, // Use Composition API mode
  locale: "en", // Default language
  fallbackLocale: "en",
  messages: { en },
  globalInjection: true, // Enables `$t()` globally without needing `useI18n()`
});

export default i18n;
